import { RootState } from "../../../rootReducer";

export const selectIsLoading = (state: RootState) => state.deleteVenues.loading;
export const selectErrorMessage = (state: RootState) =>
  state.deleteVenues.error;
export const deleteVenuesResponse = (state: RootState) =>
  state.deleteVenues.deleteVenuesResponse;
